<template>
  <div>

    <div class="field is-grouped">
      <p class="control is-expanded">
        <input class="input" type="text" placeholder="Search Users" @input="doSearch" v-model="query">
      </p>
      <p class="control">
        <a class="button is-info">
          Search
        </a>
      </p>
    </div>

    <paginator :current_page="current_page" :total_pages="total_pages" @set-page="setPage"></paginator>

    <data-table :data-set="users" :page-length="50" :allow-search="false" :columns="[
            {name: 'Account', prop: 'account_number', type: 'number'},
            {name: 'User', prop: ['first_name', 'last_name', 'email'], type: 'text'},
            {name: 'Created', prop: 'created_at', type: 'date', filter: ['moment', ['from', 'now']]},
            {name: 'Updated', prop: 'updated_at', type: 'date', filter: ['moment', ['from', 'now']]},
        ]">
      <template slot="column_Account" slot-scope="props">
        {{ props.row.account_number ? props.row.account_number : 'N/A' }}
      </template>
      <template slot="column_User" slot-scope="props">
        <router-link :to="{name:'user',params:{id:props.row.id}}">
          {{ props.row.first_name }} {{ props.row.last_name }}
          <br />
          {{ props.row.email }}
        </router-link>
      </template>
    </data-table>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import Paginator    from "../../components/misc/Paginator";
import * as types   from "../../store/mutation-types";

export default {
  name: 'user-list',
  data() {
    return {
      query: '',
      total_pages: 0,
      current_page: 1,
      per_page: 25,
      searchTimeout: 0,
    }
  },
  components: {
    'paginator': Paginator
  },
  computed: mapGetters(['users']),
  mounted() {
    this.loadPage();
  },
  methods: {
    loadPage() {
      this.$store.dispatch(types.LOAD_USERS_PAGE, {
        company: this.$store.state.company.initials,
        page: this.current_page,
        per_page: this.per_page,
        sort_dir: 'ASC',
        sort_by: 'first_name'
      }).then(d => {
        this.total_pages = d.paginator.total_pages;
      });
    },
    doSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.$store.dispatch(types.SEARCH_USERS, {
          company: this.$store.state.company.initials,
          page: this.current_page,
          per_page: this.per_page,
          sort_dir: 'ASC',
          sort_by: 'first_name',
          query: this.query,
        }).then(d => {
          this.total_pages = d.paginator.total_pages;
        });
      }, 600)
    },
    setPage(page) {
      this.current_page = page;
      this.loadPage()
    },
    deleteUser(user) {
      let confirm = window.confirm('Are you sure?');
      if (confirm) {
        this.$store.dispatch(types.DELETE_USER, user)
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// UserList.vue?56cbe33e